import { createElementClassNames } from './utils';

import styles from './Diff.module.css';

/** Shared line-state class names for unified and split diff renderers. */
export const diffElementClassNames = createElementClassNames(styles);
